import { Link, useNavigate } from "react-router-dom";
import "./login.scss";
import { AuthContext } from "../../context/authContext";
import { useContext, useState, useEffect } from "react";

const Login = () => {
  const [inputs, setInputs] = useState({
    username:"",
    password:"",
  });

  const [err, setErr] = useState(null);
  const navigate = useNavigate()

  const handleChange = (e) => {
    setInputs((prev)=>({...prev, [e.target.name]:e.target.value}))
  };

  const { login, currentUser } = useContext(AuthContext);

  useEffect(() => {
    if (currentUser) {
      navigate("/");
    }
  }, [currentUser, navigate]);



  const handleLogin = async (e) => {
    e.preventDefault();
    setErr(null);

    try{
      await login(inputs);
      // Navigation happens in useEffect when currentUser updates
    }catch(err) {
    // Ensures it's a string we can display
      const message =
        err?.response?.data?.message ||
        err?.message ||
        JSON.stringify(err);
      setErr(message);
    }
  };

  return (
    <div className="login">
      <div className="card">
        <div className="left">
          <h1>Hello World.</h1>
          <p>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero cum,
            alias totam numquam ipsa exercitationem dignissimos, error nam,
            consequatur.
          </p>
          <span>Don't you have an account?</span>
          <Link to="/register">
            <button>Register</button>
          </Link>
        </div>
        <div className="right">
          <h1>Login</h1>
          <form>
            <input 
              type="text" 
              placeholder="Username" 
              name="username" 
              onChange={handleChange}
            />
            <input 
              type="password" 
              placeholder="Password" 
              name="password" 
              onChange={handleChange}
            />
            {err && err}
            <button onClick={handleLogin}>Login</button>
          </form>
        </div>
      </div>
    </div>
  )
}

export default Login